import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LiNavLink from '../LiNavLink';

class CheckoutProgress extends Component {
  render () {
    console.log('progress props', this.props);
    var navItems = [];
    if (this.props.course.category !== 'independent'
      && this.props.course.level > 3) {
      if (this.props.inAppPurchase) {
        navItems[0] = {
          page: '/checkout/course-option',
          title: 'Course option'
        };
      } else {
        navItems[0] = {
          page: '/checkout/register',
          title: 'Register'
        };
      }
    }

    if (this.props.course.category !== 'independent') {
      navItems[navItems.length + 1] = {
        page: '/checkout/payment-type',
        title: 'Payment type'
      };
    }

    navItems[navItems.length + 1] = {
      page: '/checkout/payment-details',
      title: 'Payment details'
    };

    /* -- for when there was a waiting list
    if (!_.isEmpty(this.props.course) &&
      (this.props.course.type === 'independent' ||
      this.props.course.title.indexOf('Level 1') > -1)) {
      navItems[navItems.length + 1] = {
        page: '/checkout/payment-type',
        title: 'Payment type'
      };
      navItems[navItems.length + 1] = {
        page: '/checkout/payment-details',
        title: 'Payment details'
      };
    } -- */

    /*
    navItems[navItems.length + 1] = {
      page: '/checkout/confirm',
      title: 'Confirm'
    };
    */

    navItems[navItems.length + 1] = {
      page: '/checkout/complete',
      title: 'Complete'
    };

    /*
    <LiNavLink activeClassName='is-active' to='/checkout/payment-type'>Payment type</LiNavLink>
    <LiNavLink activeClassName='is-active' to='/checkout/payment-details'>Payment details</LiNavLink>
    <LiNavLink activeClassName='is-active' to='/checkout/confirm'>Confirm</LiNavLink>
    <LiNavLink activeClassName='is-active' to='/checkout/complete'>Complete</LiNavLink>
    */

    return (
      <nav>
        <ul className='step-nav'>
          {
            navItems.map((navItem) => (
              <LiNavLink key={navItem.title} activeClassName='is-active' to={navItem.page}>{navItem.title}</LiNavLink>
            ))
          }
        </ul>
      </nav>
    );
  }
}

CheckoutProgress.propTypes = {
  inAppPurchase: PropTypes.bool.isRequired,
  course: PropTypes.object.isRequired
};

export default CheckoutProgress;



// WEBPACK FOOTER //
// ./src/components/CheckoutProgress/index.js